import { Helmet } from 'react-helmet';

const SEO = () => {
  return (
    <Helmet>
      <title>INFI MultiChain CDEX Exchange</title>
      <meta
        name="description"
        content="INFI CDEX MultiChain Exchange is a modern cryptocurrency trading platform regulated by the proprietary ©SbSe Protocol"
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://infimultichain.com/" />
      <meta property="og:title" content="INFI MultiChain CDEX Exchange" />
      <meta
        property="og:description"
        content="INFI CDEX MultiChain Exchange is a modern cryptocurrency trading platform regulated by the proprietary ©SbSe Protocol"
      />
      <meta property="og:image" content="https://infimultichain.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="INFI MultiChain CDEX Exchange" />
      <meta
        name="twitter:description"
        content="INFI CDEX MultiChain Exchange is a modern cryptocurrency trading platform regulated by the proprietary ©SbSe Protocol"
      />
      <meta
        name="twitter:image"
        content="https://infimultichain.com/logo.png"
      />
    </Helmet>
  );
};

export default SEO;
